import React from 'react';
import { tamanhosCamisa } from '../constants';
import { Navigation } from '../components/FormControls';
import { StepProps } from './sectionTypes';

export const CamisaStep = ({ form, etapaCompleta, updateForm, onPrev, onNext }: StepProps) => (
  <section className="form-section">
    <h2><span className="section-icon">🎯</span>Camisa</h2>
    <div className="form-group">
      <label>Selecione o tamanho *</label>
      <div className="size-grid">
        {tamanhosCamisa.map((tamanho) => (
          <label className="size-option" key={tamanho}>
            <input type="radio" name="tamanhoCamisa" checked={form.tamanhoCamisa === tamanho} onChange={() => updateForm('tamanhoCamisa', tamanho)} />
            <span className="size-custom">{tamanho}</span>
          </label>
        ))}
      </div>
    </div>
    <Navigation disabled={!etapaCompleta[3]} onPrev={onPrev} onNext={onNext} />
  </section>
);
